import React, { useState } from 'react';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAppVersionCheck } from '../hooks/useAppVersionCheck';

const NewVersionBanner: React.FC = () => {
  const updateAvailable = useAppVersionCheck();
  const [dismissed, setDismissed] = useState(false);

  if (!updateAvailable || dismissed) {
    return null;
  }

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 16, sm: 24 } }}
    >
      <Alert
        severity='info'
        variant='standard'
        action={
          <>
            <Button
              color='primary'
              size='small'
              onClick={() => window.location.reload()}
            >
              Refresh
            </Button>
            <IconButton
              aria-label='Close'
              color='inherit'
              size='small'
              onClick={() => setDismissed(true)}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          </>
        }
        sx={(theme) => ({
          alignItems: 'center',
          backgroundColor: theme.palette.alert?.info?.background ?? '#E1F5FE',
          color: theme.palette.alert?.info?.color ?? '#01579B',
          border: `1px solid ${theme.palette.primary.light}`,
          boxShadow: theme.shadows[3],
          '& .MuiAlert-icon': {
            color: theme.palette.primary.main,
          },
        })}
      >
        New version available
      </Alert>
    </Snackbar>
  );
};

export default NewVersionBanner;
